import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Check, Download, X } from "lucide-react";
import { Button } from "../../../../shared/ui";

export interface TransferSubmittedSuccessModalProps {
  open: boolean;
  onClose: () => void;
  onDownloadReceipt?: () => void;
}

export const TransferSubmittedSuccessModal: React.FC<
  TransferSubmittedSuccessModalProps
> = ({ open, onClose, onDownloadReceipt }) => {
  return (
    <Dialog.Root open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40 backdrop-blur-xs transition-opacity" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-[460px] -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white p-6 shadow-xl focus:outline-hidden">
          {/* Close button */}
          <div className="flex justify-end">
            <Dialog.Close asChild>
              <button
                type="button"
                onClick={onClose}
                className="rounded-lg p-1 text-[#98A2B3] transition-colors hover:bg-[#F2F4F7] hover:text-[#344054]"
                aria-label="Close"
              >
                <X size={20} />
              </button>
            </Dialog.Close>
          </div>

          {/* Centered Celebration Graphic */}
          <div className="flex flex-col items-center py-4 text-center">
            {/* Green Check with celebration ring */}
            <div className="relative mb-4 flex h-16 w-16 items-center justify-center">
              <div className="absolute inset-0 rounded-full bg-[#ECFDF3] animate-pulse" />
              <div className="relative flex h-12 w-12 items-center justify-center rounded-full bg-[#12B76A] text-white shadow-sm">
                <Check size={24} strokeWidth={2.5} />
              </div>
            </div>

            <Dialog.Title className="text-[18px] font-bold text-neutral-900">
              OTC transfer completed
            </Dialog.Title>

            <Dialog.Description className="mt-2 text-[13px] text-neutral-500">
              The customer will be updated on the status of the transfer
            </Dialog.Description>
          </div>

          {/* Action buttons */}
          <div className="mt-6 flex items-center justify-end gap-3 border-t border-neutral-100 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onDownloadReceipt || (() => alert("Downloading receipt..."))}
              className="gap-2"
            >
              <Download size={16} />
              <span>Download receipt</span>
            </Button>

            <Button
              type="button"
              onClick={onClose}
              className="px-6"
            >
              Done
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
